module.exports = "<div ng-transclude>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpComponentCategory/adpComponentCategory.html
// module id = 465
// module chunks = 0